import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { editorOptions } from 'src/app/constants/editor-options';
import { url } from 'src/app/constants/regex';
import { product, ticket } from 'src/app/constants/ts-and-cs';
import { IEditListingConfig } from 'src/app/interfaces/edit-listing-config';
import { CarouselImageDataSource } from 'src/modules/carousel-image/services/carousel-image-data-source';

@Component({
    selector: 'listing-edit-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class ListingEdit implements OnInit {
  public form: FormGroup;

  public editorOptions = editorOptions;
  public CarouselImageDataSource: CarouselImageDataSource;
  public existingListing: boolean;
  public startDate: string = null;
  public endDate: string = null;
  public ticketTsAndCs = ticket;
  public productTsAndCs = product;
  public marked: boolean;
  public editiframe = false;
  public iframe: {
    url: string;
    title: string;
  };

  private features: string[] = [
    'national',
    'promoted_event',
    'external_url',
    'button_text',
    'terms_and_conditions',
    'video',
    'iframe',
    'retired',
  ];

  constructor(
    protected dialogRef: MatDialogRef<ListingEdit>,
    @Inject(MAT_DIALOG_DATA) public config: IEditListingConfig
  ) {}

  ngOnInit() {
    this.CarouselImageDataSource = this.config.CarouselImageDataSource;
    !!this.CarouselImageDataSource && this.CarouselImageDataSource.load();

    const { Listing } = this.config;
    this.existingListing = !!Listing;

    this.form = new FormBuilder().group({
      title: [null, [Validators.required]],
      description: [null, [Validators.required]],
      colour_scheme: [null],
      search_terms: [null],
      start_date: [null],
      end_date: [null],
      video: [null],
      iframe: new FormBuilder().group({
        url: [null],
        title: [null],
      }),
      offer_label: [null],
      offer: [null],
      offer_terms: [null],
      national: [null],
      promoted_event: [null],
      external_url: [null],
      button_text: [null],
      retired: [null],
      terms_and_conditions: [null, Validators.pattern(url)],
    });

    if (this.existingListing) {
      Object.keys(Listing).forEach((name) => {
        if (this.form.controls[name]) {
          this.form.controls[name].patchValue(Listing[name]);
        }
      });

      if (Listing.features) {
        Object.keys(Listing.features).forEach((name) => {
          if (this.form.controls[name]) {
            this.form.controls[name].patchValue(Listing.features[name]);
          }
        });
      }

      this.form.controls['colour_scheme'].patchValue(
        Listing.colour_scheme || 'default'
      );

      this.startDate = Listing.start_date;
      this.endDate = Listing.end_date;
      this.iframe == Listing.features['iframe'];
    }
  }

  onSubmit() {
    this.form.disable();
    const _Listing = {
      ...this.getRawListing(),
    };

    this.features.forEach((featureName) => {
      _Listing[featureName]
        ? (_Listing.features[featureName] = _Listing[featureName])
        : delete _Listing.features[featureName];

      delete _Listing[featureName];
    });

    !_Listing.features.iframe.url && delete _Listing.features.iframe;

    this.config.DataSource.save(_Listing).then(
      (listingId) => {
        return this.dialogRef.close(Object.assign({ id: listingId }, _Listing));
      },
      () => this.form.enable()
    );
  }

  public toggleIframe() {
    this.editiframe = !this.editiframe;
  }

  public setIframe() {
    const { iframe } = this.form.getRawValue();

    this.iframe = iframe;

    this.toggleIframe();
  }

  public clearIframe() {
    const iframe = {
      url: null,
      title: null,
    };

    this.form.patchValue({ iframe });

    this.iframe = iframe;
  }

  private getRawListing() {
    const {
      Listing,
      organisationId: company_id,
      branchId: branch_id,
    } = this.config;

    const base = { company_id, branch_id };
    const features =
      this.existingListing && !Array.isArray(Listing.features)
        ? Listing.features
        : {};
    const form = this.form.getRawValue();

    const description = form.description.replace(/<p><br><\/p>/g, '');

    this.existingListing && (base['id'] = Listing.id);

    return {
      ...base,
      features,
      ...form,
      description,
    };
  }

  setVideoUrl(e) {
    this.marked = e;
  }
}
